import { GET_HURRICANE_OUTLOOK_SUMMARY } from "../../../../actions/Hurricane/Outlook/Summary/hurricaneOutlookSummaryAction";
import {
	HurricaneOutlookSummaryPayload
} from "../../../../types/APIResponses/Hurricane/Outlook/hurricaneOutlookSummaryResponses";

export interface HurricaneOutlookSummaryReducerState {
	data?: HurricaneOutlookSummaryPayload;
	isFetching: boolean;
	requestError?: boolean | Record<string, unknown> | unknown;
}

const initialState: HurricaneOutlookSummaryReducerState = {
	data: undefined,
	isFetching: false,
	requestError: undefined
};

export function hurricaneOutlookSummary(state = initialState, action) {
	switch (action.type) {
		case GET_HURRICANE_OUTLOOK_SUMMARY.pending:
		{
			return {
				...state,
				requestError: undefined,
				isFetching: true
			};
		}

		case GET_HURRICANE_OUTLOOK_SUMMARY.fulfilled:
		{
			return {
				...state,
				data: action.payload,
				isFetching: false,
				requestError: undefined
			};
		}

		case GET_HURRICANE_OUTLOOK_SUMMARY.rejected:
		{
			return {
				...state,
				data: undefined,
				isFetching: false,
				requestError: action.payload
			};
		}
		default:
		{
			return state;
		}
	}
}

